import moment from "moment";

export namespace IAgentReport {
  export interface IDataItem {
    payDate: string;
    cntPays: number;
    sumPays: number;
    finalScore?: boolean;

    // FE props.
    avgSum?: number;
    payDateDay?: string;
  }

  export interface IAgentPrintDocument {
    agent: { // Агент (Исполнитель)
      name: string;
      inn: number;
      ogrn: number;
    }
    client: { // Принципал (Заказчик)
      name: string;
      inn: number;
      kpp: number;
      nds?: number;
    }
    order: {
      agentNumber: number; // ОТЧЕТ АГЕНТА № в заголовке
      docNumber: string; // № договора
      docDate: string; // дата договора
      period: { // период оказания услуги
        end: string
        start: string;
      };
      sum: IAgentSummary;
    }
    corpPays?: {
      clientName: string;
      clientCharges: number;
      clientSum: number;
    }[];
  }

  export interface IAgentSummary {
    agent: number; // Вознаграждение агента
    corpSum: number; // Сумма, полученная от юр. лиц
    clientSum: number; // Сумма, полученная от пользователей
    customerSum: number; // Сумма к перечислению заказчику
    nds?: number;
  }

  export function mappingTableData(tableData: IDataItem[], usedGrouping: boolean) {
    return tableData.map((row: IDataItem) => {
      let avgSum = 0;
      if (!usedGrouping) {
        avgSum = Math.ceil(row.sumPays / row.cntPays);
      }
      return {
        ...row,
        avgSum,
        payDateDay: row.payDate ? moment(row.payDate).format('ddd') : '',
      }
    });
  }
}